module.exports = __webpack_public_path__ + "media/images/svg-sprite-items/payment/payment-on-invoice-fr-9445a6b58252cd3792b24803faebf074.svg";